module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp9-9d7d3772d57f7478d0712cc3fef7b3d4.jpg";